import React from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";

function ReportById({ apiPath, title, titleLink }) {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { id } = useParams();
  const { data: tableData = [], isLoading: tableIsLoading } =
    useGetProtectedApiDataQuery({
      url: apiPath,
      lang: languageType,
    });

  const tableObj = tableData.find((item) => item.nid === id);

  if (tableIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Reports", "रिपोर्ट्स")}
        titleLink={titleLink}
        levelTwo={true}
        levelThree={true}
        isActive={tableObj.title}
        titleTwo={tableObj.field_equity_category}
        titleThree={tableObj.title}
        titleLink2={titleLink}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div
                    dangerouslySetInnerHTML={{ __html: tableObj.body }}
                  ></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default ReportById;
